import React from "react";
import {Helmet} from "react-helmet-async";

// Renders a schema.org JSON-LD block into <head> via react-helmet-async (same mechanism
// MetaComponent already uses for <title>/<meta>) - structured data read by search engines'
// rich-result parsers and, increasingly, by LLM answer engines (ChatGPT/Claude/Perplexity/Google
// AI Overviews) looking for unambiguous, machine-readable facts about a page rather than having to
// infer them from prose. `data` is a plain object (or array of objects for multiple blocks on one
// page) already shaped like schema.org JSON - this component only handles serializing/injecting
// it, not building it (see callers for the actual schema shape per page type).
export default function JsonLd({data}) {
  if (!data) return null;
  const items = Array.isArray(data) ? data : [data];
  return (
      <Helmet>
          {items.map((item, i) => (
              <script key={i} type="application/ld+json">
                {JSON.stringify(item)}
              </script>
          ))}
      </Helmet>
  );
}
